import axios from 'axios';

const baseApiUrl = 'api/bild';

export default class BildService {
  public retrieveBilder(id: number, type: number): Promise<any> {
    return axios.get(`${baseApiUrl}/${id}/${type}`);
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public create(entity): Promise<any> {
    //const tocken = btoa(loginString);
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(res => {
          resolve(res.data);
        });
    });
  }
}
